import { getGlobalHeadersAsObject } from "../global-headers";
import type { DRFListResponseWrapper } from "../types";

export type PersonExperienceRole = {
	id: number;
	title: string;
	timedelta_for_role: number;
	location: string;
	location_map_id: number | null;
	ostmd_id: number | null;
	// legacy fields (deprecated; read-only)
	start_date: string;
	end_date: string;
	// normalized fields (source of truth for logic)
	start_dt: string | null;
	end_dt: string | null;
	current: boolean;
	description: string;
	skills: string[];
};

export type PersonExperienceType = {
	id: number;
	name: string;
	timedelta_for_employer: number;
	company_id: number;
	company_size: number;
	company_ammount_employees_cache: number;
	company_linkedin: string;
	company_linkedin_named_id: string;
	company_website: string;
	// legacy (deprecated)
	duration?: string;
	roles: PersonExperienceRole[];
};

export const getPersonExperiencesById = (
	personId: number,
	highlightAssignmentId?: number
): Promise<DRFListResponseWrapper<PersonExperienceType[]>> => {
	if (!personId || typeof personId !== "number") {
		throw new Error(
			`getPersonExperienceById called with invalid argument id '${personId}'. Expected number`
		);
	}

	const params = new URLSearchParams();
	if (highlightAssignmentId) {
		params.append("highlight", highlightAssignmentId.toString());
	}

	const url = `/api/v2/persons/${personId}/experiences/${
		params.toString() ? `?${params.toString()}` : ""
	}`;

	return fetch(url, {
		method: "GET",
		headers: getGlobalHeadersAsObject(),
	}).then((res) => res.json());
};
